<template>
  <div class="card">
    <div class="card-content has-text-centered">
      <b-field
        :label="$t('components.signingSteps.signatureProviderSelection.providerSelectionLabel')"
      >
        <b-select
          v-model="signatureProviderSelection"
          :placeholder="$t('components.signingSteps.signatureProviderSelection.providerSelectionPlaceholder')"
          class="has-text-centered"
          :disabled="getSignatureProviders.length === 0"
        >
          <optgroup :label="$t('components.signingSteps.signatureProviderSelection.optGroupMain')">
            <option
              v-for="provider in getSignatureProviders"
              :value="provider"
              :key="provider.id"
            >
              {{ provider.name }}
            </option>
          </optgroup>
          <optgroup :label="$t('components.signingSteps.signatureProviderSelection.optGroupInternal')">
            <option
              v-for="provider in getInternalSignatureProviders"
              :value="provider"
              :key="provider.id"
            >
              {{ provider.name }}
            </option>
          </optgroup>
        </b-select>
      </b-field>

      <div
        class="notification"
        v-show="!isEmpty(signatureProviderSelection) && signatureProviderSelection.description"
      >
        <div class="content">
          <p>
            {{ signatureProviderSelection.description }}
          </p>
        </div>
      </div>
    </div>

    <footer
      class="card-footer"
      v-show="!isEmpty(signatureProviderSelection)"
    >
      <a
        @click="confirmSignatureProviderSelection"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.signatureProviderSelection.confirmSelectionLabel') }}

        <b-icon icon="chevron-right">
        </b-icon>
      </a>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { objectUtils } from '@/mixins/objectUtils'

export default {
  name: 'SignatureProviderSelection',
  mixins: [objectUtils],
  data () {
    return {
      // TODO: According to https://github.com/buefy/buefy/issues/784 I have to
      //       set this to null for the selection placeholder text to appear,
      //       but currently, if you do this, the selection doesn't appear at
      //       all.
      signatureProviderSelection: {}
    }
  },
  mounted () {
    this.loadSignatureProviders()
      .catch(error => {
        // TODO: Temporary workaround for babel-transform-remove-console plugin
        //       not working.
        // eslint-disable-next-line
        console.error('GET /api/providers failed with error: ', error.message)

        this.$buefy.toast.open({
          duration: 3500,
          message: this.$t('components.signingSteps.signatureProviderSelection.signatureProvidersRetrievalFailedToast'),
          position: 'is-bottom',
          type: 'is-danger'
        })
      })
  },
  computed: {
    ...mapGetters([
      'getSignatureProviders',
      'getInternalSignatureProviders'
    ])
  },
  methods: {
    ...mapActions([
      'loadSignatureProviders',
      'setSelectedSignatureProvider'
    ]),
    confirmSignatureProviderSelection () {
      this.setSelectedSignatureProvider(this.signatureProviderSelection)

      this.$emit('signatureProviderSelected')
    }
  }
}
</script>
